// ============================================
// src/features/groups/hooks/useGroupValidation.ts
// ============================================

import { useTranslate } from 'react-admin';
import { GroupFormData, GroupValidationErrors } from '../types';

export const useGroupValidation = () => {
  const translate = useTranslate();
  
  const validateGroupName = (value: string | undefined): string | undefined => {
    if (!value || !value.trim()) {
      return translate('resources.groups.validation.name_required', 'El nombre del grupo es obligatorio');
    }
    
    if (value.trim().length < 2) {
      return translate('resources.groups.validation.name_too_short', 'El nombre debe tener al menos 2 caracteres');
    }
    
    if (value.trim().length > 100) {
      return translate('resources.groups.validation.name_too_long', 'El nombre no puede exceder 100 caracteres');
    }
    
    return undefined;
  };
  
  const validateDescription = (value: string | undefined): string | undefined => {
    if (value && value.length > 500) {
      return translate('resources.groups.validation.description_too_long', 'La descripción no puede exceder 500 caracteres');
    }
    
    return undefined;
  };
  
  const validateForm = (data: GroupFormData): GroupValidationErrors => {
    const errors: GroupValidationErrors = {};
    
    const nameError = validateGroupName(data.name);
    if (nameError) errors.name = nameError;
    
    const descError = validateDescription(data.description);
    if (descError) errors.description = descError;
    
    return errors;
  };
  
  const hasErrors = (errors: GroupValidationErrors): boolean => {
    return Object.keys(errors).length > 0;
  };
  
  return {
    validateGroupName,
    validateDescription,
    validateForm,
    hasErrors,
  };
};

